(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productSalesPriceProvider', productSalesPriceProvider);

    productSalesPriceProvider.$inject = ['$cacheFactory', '$q', '$log', '_', 'mainWorkspace', 'priceCalculationWorkflow'];

    function productSalesPriceProvider($cacheFactory, $q, $log, underscore, mainWorkspace, priceCalculationWorkflow) {
        var cache = $cacheFactory('ProductSalesPrices');

        return {
            getSalesPrice: getSalesPrice,
            getMaterialSalesPrice: getMaterialSalesPrice,
            getColourSalesPrice: getColourSalesPrice,

            clearCache: clearCache
        };

        // ------------------------------------ Public functions --------------------------------------

        function clearCache() {
            $log.debug('Clear sales prices cache');
            cache.removeAll();
        }

        function getSalesPrice(product) {
            if (!isReadyProductForCalculatePrice(product)) {
                return null;
            }

            var productInfo = product.getProductInfo();
            return getFromCacheOrCalculateSalePrice(productInfo);
        }

        function getMaterialSalesPrice(product, material) {
            if (!isReadyProductForCalculatePrice(product)) {
                return null;
            }

            var productInfo = product.getProductInfo();
            productInfo.materialId = material.id;
            productInfo.colourId = material.colours[0].id;
            productInfo.quantity = 1;

            return getFromCacheOrCalculateSalePrice(productInfo);
        }

        function getColourSalesPrice(product, material, colour) {
            if (!isReadyProductForCalculatePrice(product)) {
                return null;
            }

            var productInfo = product.getProductInfo();
            productInfo.materialId = material.id;
            productInfo.colourId = colour.id;
            productInfo.quantity = 1;

            return getFromCacheOrCalculateSalePrice(productInfo);
        }

        // -------------------------------------------------------------------------------------

        function getFromCacheOrCalculateSalePrice(productInfo) {
            var key = buildCacheKey(productInfo);
            var salesPriceCached = cache.get(key);

            if (!salesPriceCached) {
                salesPriceCached = runCalculateSalesPrice(productInfo);
                cache.put(key, salesPriceCached);
            }

            return salesPriceCached;
        }

        function runCalculateSalesPrice(productInfo, canceler) {
            $log.debug('runCalculateSalesPrice ', productInfo);

            var priceWorkflow = new priceCalculationWorkflow.Instance();
            priceWorkflow.calculate(productInfo, mainWorkspace.options.currencyId, canceler);

            return priceWorkflow.salesPrice;
        }

        function buildCacheKey(productInfo) {
            var values = underscore.values(productInfo);
            return values.join('_');
        }

        function isReadyProductForCalculatePrice(product) {
            return product.material() && product.colour() && product.isReady() && (!product.model.issue || product.model.issue.isQuestion());
        }
    }
}());